import React from 'react';

import dynamic from 'next/dynamic';

import { useFeatures } from '@atc/features';

import useCustomContent from '@/hooks/useCustomContenbt';

import { DynamicPlaceholder } from '@/components/DynamicPlaceholder/DynamicPlaceholder';
import LazyComponent from '@/components/LazyComponent';

const heights = {
    xs: 385,
    sm: 353,
    md: 325,
    lg: 325,
};
const SeoCustomContent = dynamic(() => import(
    /* webpackChunkName: "SeoCustomContent" */
    '@/components/SeoCustomContent'
), {
    ssr: false,
    loading: () => (
        <DynamicPlaceholder height={heights} />
    ),
});

export default function SrpSeoContentContainer() {
    const {
        srp_bottom_lazy_threshold: [, { defaultThreshold }],
    } = useFeatures([
        'srp_bottom_lazy_threshold',
    ]);

    const { isEnableCustomContent } = useCustomContent();

    return isEnableCustomContent && (
        <LazyComponent
            height={heights}
            threshold={defaultThreshold}
        >
            <SeoCustomContent />
        </LazyComponent>
    );
}
